module.exports = __webpack_public_path__ + "img/health7_7-9-2021.a56b820f.jpg";